import { render, staticRenderFns } from "./transform-pm-modal.vue?vue&type=template&id=1dae8152&scoped=true"
import script from "./transform-pm-modal.vue?vue&type=script&lang=js"
export * from "./transform-pm-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dae8152",
  null
  
)

export default component.exports